export const MOBILE_SEO_TRAFFIC_STAG = '218217_669e6d608d2506ff26fe83c5';
export const SEARCH_ENGINES = ['google', 'bing'];
